import { Component, Inject } from '@angular/core';
import { Constant } from '../../constant';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonUtil } from '../../util/common-util';
import { ToastUtil } from '../../util/toast-util';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../../auth/auth.service';

@Component({
    selector: 'app-account-password-reset-dialog',
    templateUrl: './account-password-reset-dialog.component.html',
    styleUrl: './account-password-reset-dialog.component.css',
    standalone: false
})
export class AccountPasswordResetDialogComponent {
  public readonly Constant = Constant;
  public form: FormGroup;
  public isSaving = false;
  public maxLenColor = 6
  //public mainColor
  public colorPreviewId = 'main-color-preview'
  private apiPath = '/account';
  public auths;
  public accountAuth;
  public mailaddress;
  public account;
  public showSpinner = true;
  constructor(
    public dialogRef: MatDialogRef<AccountPasswordResetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private auth: AuthService,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
  ) {
    //this.mainColor = data.mainColor
    this.auths = [
      { label: '管理', value: '0' },
      { label: '準管理', value: '1' },
      { label: '運用', value: '2' },
      { label: 'メンバー', value: '3' },
      { label: 'なし（未承認）', value: '4' }
    ];
  }


  ngOnInit() {
    if (this.data.id !== 0) {
      this.getDetail();
    } else {
      this.account = {
        mailaddress: Constant.empty,
        accountAuth: Constant.empty,
      };
      this.initForm()
      this.showSpinner = false;
    };
  }

  onSave() {
    if (!this.commonUtil.checkOnline()) {
      this.isSaving = false;
      return;
    }

    if (this.isSaving) {
      return;
    }

    this.isSaving = true;
      this.dataUpdate();
  }

  onInput() {
    const mail_address = this.form.value.mail_address;

    if (mail_address.length < 6) {
      return
    }

  }

  onChange() {
    const auth = this.form.value.accountAuth;

    if (auth.length < 6) {
      return
    }

  }

  onCompositionEnd() {
    this.onInput()
  }

  // 無効の場合保存済みに戻す
  onBlur() {
    if (!this.checkColorCode(this.form.value.main_color)) {
      this.form.patchValue({
        main_color: this.data.mainColor
      })
      //this.mainColor = this.data.mainColor
      this.colorPreview()
    }
  }

    /* プライベート */
  // 詳細取得
  private getDetail() {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
      this.dialogRef.close();
      return;
    }

    Auth.currentSession().then(session => {
      const apiPath = this.apiPath + '/detail/' + this.data.id;
      const options = this.auth.createApiHeader(session);
      this.commonUtil.apiGet(apiPath, options).then(res => {
        if (!res.data) {
          // 削除済み
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgDeleteAccountAlreadyError, Constant.toastShowMiliSec);
          this.dialogRef.close(true);
          return;
        }
        this.account = res.data;
        this.initForm();
        this.showSpinner = false;
      })
      .catch(err => {
        this.commonUtil.debug().log(err);
        if (err.message === Constant.msgLoginFailed) {
          this.commonUtil.showReloadDialog(this.auth);
        } else {
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
          this.dialogRef.close();
        }
      });
    });
  }

  private initForm() {
    this.form = new FormGroup({
      mailaddress: new FormControl(this.account.user_id, [Validators.required]),
      accountAuth: new FormControl(
        String(this.account.user_authority),
        Validators.required
      ),
    });
    //this.form.get('mailaddress')?.disable({ emitEvent: false });
    this.form.get('accountAuth')?.disable({ emitEvent: false });
  }

  // プレビューの色変更
  private colorPreview() {
    const prev = document.getElementById(this.colorPreviewId)
    if (prev) {
      //prev.setAttribute('style', 'background-color:#' + this.mainColor)
    }
  }

  // カラーの16進数チェック
  private checkColorCode(colorText) {
    return /^[0-9A-F]{6}$/i.test(colorText)
  }

  // 登録実行
  private dataUpdate() {
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      options['body'] = {
        user_id: this.account.user_id,
      };
      console.log(options)
      this.commonUtil
        .apiPost(this.apiPath + '/password', options)
        .then(res => {
          if (res.status === Constant.OK) {
            this.toastUtil.showInformationToast('', Constant.msgResultpasswordResetSuccess, Constant.toastShowMiliSec);
            this.dialogRef.close(res.status);
          }
        })
        .catch(err => {
          this.commonUtil.debug().log(err);
          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else if(err.message == "対象のユーザーが存在しません。") {
            this.toastUtil.showErrorToast('', Constant.msgDeleteAccountAlreadyError, Constant.toastShowMiliSec);
            this.dialogRef.close(Constant.NG);
          } else {
            this.toastUtil.showErrorToast('', Constant.msgSaveFailedRetry, Constant.toastShowMiliSec);
          }
          this.isSaving = false;
        });
    });
  }
}
